module.exports = __webpack_public_path__ + "media/components/src/assets/images/before_and_after/before_after_2-96d2e2b2455f28db48ad264e4e760ff4.jpg";